import {mapGetters, mapActions}    from 'vuex'

import { io }         from "socket.io-client";
import axios from 'axios';
import { runKpiNotification } from '@/utils/socketKpiNotificationDefer'
import {
  parseExamenCompletadoPayload,
  guardarExamenAbrirPendiente,
  nombreRutaTwilioExamen,
} from '@/utils/examenUbicacionNotify'
import {
  debeParticiparPrueba,
  ejecutarPruebaWhatsappRendimiento,
} from '@/utils/pruebaWhatsappRendimiento'
import { IDERP_NAOMI_PALMA } from '@/utils/permisosNaomiMenu'
import { setPagosCursoPendientes } from '@/utils/pagosCursoAviso'

export default {
	data () {
		return {
			socket:null,
      socketKPI: null,
      socketTwilio: null,
      mensajeProceso:'',
      alertaSinTeacher:{
        estatus: false,
        mensaje: '',
      },

      alertaTwilioRh:{
        estatus: false,
        mensaje: '',
        wa: '',
        type: 'teal darken-1',
      },

      alertaNuevaVenta:{

        estatus: false,
        mensaje: null
      },

      alertaNuevaRI:{

        estatus: false,
        mensaje: null
      },

      alertaSinSeguimiento:{
        estatus: false,
        mensaje: null
      },

      alertaEquipoUso: {
        estatus: false,
        info: null
      },

      notificaciones:[],
		}
	},
  watch: {
    getdatosUsuarioERPERP(usuario) {
      if (usuario) {
        this.inicializarSockets();
      } else {
        this.desconectarSockets();
      }
    }
  },

	computed: {
    ...mapGetters('login' ,[ 'getdatosUsuarioERPERP' ]),
		...mapGetters('twilio',[ 'getConversaciones', 'getConversacionesM', 'getConversacionesG', 'getConversacionesC', 'getConversacionesFast', 'getConversacionesAgente', 'getConversacionesCRM','getConversacionesCRMFast' ]),
	},

	mounted() {
    // Si ya hay usuario al montar
    if (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) {
      this.inicializarSockets();
    }
  },

  beforeDestroy () {
    this.desconectarSockets()
  },

  methods: {

    onPruebaWhatsappRendimiento (body) {
      const u = this.getdatosUsuarioERPERP
      if (!u || !debeParticiparPrueba(u)) return
      const batchId = body && (body.batchId || body.batch_id)
      if (!batchId) return
      ejecutarPruebaWhatsappRendimiento(this.$http, u, batchId).catch((err) => {
        console.warn('[prueba-whatsapp-rendimiento]', err)
      })
    },

    onAccesoSistemaBloqueo (body) {
      const u = this.getdatosUsuarioERPERP
      if (!u || !body) return
      const miId = u.iderp || u.id_usuario
      if (Number(body.id_usuario) !== Number(miId)) return
      if (typeof this.aplicarEstadoAccesoBloqueado === 'function') {
        this.aplicarEstadoAccesoBloqueado({
          bloqueado: body.bloqueado,
          motivo: body.motivo || '',
        })
      }
    },

    /** Clic en toast vue-notification (App.vue slot). */
    onKpiNotifyClick (item, close) {
      const closeFn = typeof close === 'function' ? close : () => {}
      if (item.data && item.data.accion === 'examen-ubicacion') {
        closeFn()
        this.irATwilioExamenCompletado(item.data)
        return
      }
      closeFn()
    },

    /** Twilio según escuela del prospecto: 1 = Unificado, 2 = FAST. */
    irATwilioExamenCompletado (payload) {
      if (!payload) return
      guardarExamenAbrirPendiente(payload)
      const query = {}
      if (payload.folio) query.folio = String(payload.folio).trim()
      if (payload.idprospectos) query.idprospectos = String(payload.idprospectos)
      if (payload.escuela != null) query.escuela = String(payload.escuela)
      const routeName = nombreRutaTwilioExamen(payload.escuela)
      this.$router.push({ name: routeName, query }).catch(() => {})
    },

    ...mapActions('twilio', ['guardarConversaciones', 'guardarConversacionesM', 'guardarConversacionesG', 'guardarConversacionesC', 'guardarConversacionesFast', 'guardarConversacionesAgente', 'guardarConversacionesCRM', 'guardarConversacionesCRMFast'] ),

    inicializarSockets() {
      const base = axios.defaults.baseURL || '';
      let url;
      if (base.startsWith('/')) {
        const port = process.env.VUE_APP_API_PORT || '3004';
        url = `${window.location.protocol}//${window.location.hostname}:${port}/`;
      } else if (process.env.VUE_APP_SOCKET_URL) {
        url = process.env.VUE_APP_SOCKET_URL.replace(/\/?$/, '/');
      } else if (base.includes('schoolofenglishadmin.com')) {
        // Proxy /kpi-proxy/ en el front; socket al host del API (staging: wharecepinbi, prod: escuelakpi)
        url = (process.env.VUE_APP_SOCKET_URL || 'https://escuelakpi.club').replace(/\/?$/, '/');
      } else {
        url = base.replace('kpi/', '');
        if (url && !url.endsWith('/')) url += '/';
      }

    // Modo servidor (staging LOCAL=3: /wss/socket.io vía VUE_APP_SOCKET_PATH)
    const path = process.env.VUE_APP_SOCKET_PATH || '/ws/socket.io'
    const usuarioId = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp

    // Socket para el KPI
    if( !this.socketKPI ){
      console.log('[socket-kpi] conectando (tickets/alertas)', {
        url,
        path,
        usuarioId,
        envSocketUrl: process.env.VUE_APP_SOCKET_URL || null,
        envSocketPath: process.env.VUE_APP_SOCKET_PATH || null,
        apiBase: base || null,
      })

      // Socket KPI: tickets, alertas, ventas, bloqueos, etc. (escuelakpi / staging)
      this.socketKPI = io(url, {
        transports: ["websocket"],
        path,
        query: {
          usuarioId // cada conexion manda el su iderp al servior
        }
      });

      this.socketKPI.on("connect", ( ) => {
        console.log('[socket-kpi] CONNECT ok', {
          id: this.socketKPI && this.socketKPI.id,
          url,
          path,
          usuarioId,
        })
      });

      this.socketKPI.on('connect_error', (err) => {
        console.warn('[socket-kpi] CONNECT_ERROR', {
          message: err && err.message,
          url,
          path,
        })
      });

      this.socketKPI.on("pago-curso-validacion", (body) => {
        var total = body && body.total != null ? Number(body.total) : 0
        setPagosCursoPendientes(total)
      })

      // Notificacion de ticket asignado
      this.socketKPI.on("notificacion-para", (msj) => {
        if (msj && typeof msj === 'object' && msj.tipo === 'twilio-rh-handoff') {
          runKpiNotification(() => {
            this.alertaTwilioRh.estatus = true
            this.alertaTwilioRh.mensaje = msj.mensaje || 'Un postulante necesita a una reclutadora.'
            this.alertaTwilioRh.wa = String(msj.wa || '').replace(/\D/g, '').slice(-10)
            this.alertaTwilioRh.type = 'teal darken-1'
          })
          if (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) {
            this.getNotificaciones()
          }
          return
        }

        const esCambioSucursal = msj && typeof msj === 'object' && msj.tipo === 'cambio-sucursal'
        const mensaje = esCambioSucursal ? msj.mensaje : msj

        runKpiNotification(() => {
          this.$notify({
            group: 'foo',
            title: 'Nueva notificacion:',
            text: `${ mensaje } 🚀`,
            type: esCambioSucursal ? 'white' : 'ticket-blue',
            duration: 10000
          });
        })

        if (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) {
          this.getNotificaciones()
        }
      });

      // Genera el socket para escuchar un ticket
      this.socketKPI.on('notificacion-pago-rechazado', ( body ) => {
        runKpiNotification(() => {
          // Mismo plantel, o Naomi (2781): siempre ve la alerta activa
          const u = this.getdatosUsuarioERPERP
          const mismoPlantel = u && u.id_plantel == body.id_plantel
          const verSiempre = u && Number(u.iderp) === IDERP_NAOMI_PALMA
          if( mismoPlantel || verSiempre ){
            const motivo = body.motivo || ''
            const plantelPago = body.plantel_pago || body.plantel_alumno || ''
            const alumno = body.nombre_alumno || ''
            const ingresadoPor = body.usuario_ingreso || body.nombreEmpleado || ''
            const fechaPago = body.fecha_pago || ''
            const esEliminado = body.tipo === 'eliminado' || body.tipo === 'eliminado_automatico'
            const accion = esEliminado ? 'eliminado' : 'rechazado'
            const origen =
              body.tipo === 'eliminado_automatico'
                ? 'automáticamente por el sistema'
                : 'por un usuario administrativo'
            const tieneDetalle = plantelPago || alumno || ingresadoPor || fechaPago

            const mensajePrincipal = tieneDetalle || motivo
              ? `El ingreso <b>${body.id_ingreso || ''}</b> ha sido ${accion} ${origen}${motivo ? `, por el motivo: <b>${motivo}</b>` : ''}.`
              : (body.mensaje || 'Se rechazó o eliminó un pago.')

            const detalleHtml = tieneDetalle
              ? `
                <div style="
                  margin-top: 12px;
                  background: #f3f4f6;
                  border-radius: 8px;
                  padding: 10px 12px;
                  text-align: left;
                  font-size: 13px;
                  line-height: 1.45;
                  color: #374151;
                ">
                  <div style="font-weight: 700; color: #111827;">
                    ${plantelPago || 'Sin sucursal'}: ${alumno || 'Sin alumno'}
                  </div>
                  <div style="margin-top: 4px;">
                    <span style="font-weight: 600;">Ingresó:</span> ${ingresadoPor || 'No registrado'}
                    ${fechaPago ? ` · <span style="font-weight: 600;">Fecha:</span> ${fechaPago}` : ''}
                  </div>
                </div>
              `
              : ''

            const relacionados = Array.isArray(body.alumnos_relacionados)
              ? body.alumnos_relacionados
              : []
            const relacionadosHtml = relacionados.length
              ? `
                <div style="
                  margin-top: 12px;
                  background: #fef2f2;
                  border: 1px solid #fecaca;
                  border-radius: 8px;
                  padding: 10px 12px;
                  text-align: left;
                  font-size: 13px;
                  line-height: 1.45;
                  color: #7f1d1d;
                ">
                  <div style="font-weight: 700; color: #991b1b; margin-bottom: 6px;">
                    Mismo comprobante también usado en:
                  </div>
                  <ul style="margin: 0; padding-left: 18px;">
                    ${relacionados.map((r) => {
                      const nombre = (r && r.alumno) || 'Sin alumno'
                      const mat = (r && r.matricula) || '—'
                      const idIng = (r && r.id_ingreso) || '—'
                      const fecha = (r && r.fecha_pago) || '—'
                      return `<li style="margin-bottom: 4px;"><b>${nombre}</b> · Mat. ${mat} · Ingreso ${idIng} · ${fecha}</li>`
                    }).join('')}
                  </ul>
                </div>
              `
              : ''

            this.$swal({
              title: 'Pagos rechazados/eliminados',
              html: `
                <div style="text-align: left; font-size: 15px; color: #374151;">
                  ${mensajePrincipal}
                  ${detalleHtml}
                  ${relacionadosHtml}
                </div>
              `,
              icon: 'error',
              showConfirmButton: true,
              confirmButtonText: 'OK'
            });
          }
        })
      })
        

      // Genera el socket para escuchar un ticket
      this.socketKPI.on('respuesta-ticket', ( body ) => {
        runKpiNotification(() => {
          const iderpSesion = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
          const esParaDueno = iderpSesion == body.id_usuario
          const permisos = (this.$store && this.$store.getters['login/getPermisosRutas']) || []
          const puedeRevisarComisiones =
            permisos.indexOf('Nomina') >= 0 ||
            permisos.indexOf('EncargadasComisiones') >= 0 ||
            permisos.indexOf('AutorizacionNomina') >= 0
          const esParaRevisor =
            body.para_revisores_comisiones &&
            puedeRevisarComisiones &&
            iderpSesion != body.id_usuario_comisiones

          if (esParaDueno || esParaRevisor) {
            this.alertaSinTeacher.estatus = true
            this.alertaSinTeacher.mensaje = body.mensaje
            this.alertaSinTeacher.type    = body.type ? body.type : 'success'
            // Dueño: abrir Mis Comisiones. Revisor: solo toast (entra por Nómina).
            const mensajeTexto = body.mensaje ? String(body.mensaje).toLowerCase() : ''
            if (esParaDueno && mensajeTexto.indexOf('comision') >= 0 && this.paramsComisiones) {
              this.paramsComisiones.estatus = true
            }
          }
        })
      })

      // Socket para saber si estoy desconectado del socket
      this.socketKPI.on("disconnect", (reason) => {
        console.warn('[socket-kpi] DISCONNECT', { reason })
        runKpiNotification(() => {
          this.alertaSinTeacher.estatus = true
          this.alertaSinTeacher.mensaje = 'Tu socket se ha Desconectado'
          this.alertaSinTeacher.type    = 'error'
        })
      });

      // // Socket para escuchar si se envió o recibió algún mensaje
      this.socketKPI.on("nueva-venta", ( body ) => {
        runKpiNotification(() => {
          if( localStorage.getItem('notificaciones') && localStorage.getItem('notificaciones') === 'false') return
          this.alertaNuevaVenta.estatus = true
          this.alertaNuevaVenta.mensaje = body
          this.alertaNuevaVenta.type    = 'success'
        })
      });

      this.socketKPI.on("nueva-ri", ( body ) => {
        runKpiNotification(() => {
          this.$notify({
            group: 'foo',
            title: 'Nuevo RI:',
            text: `${ body.mensaje } 🚀`,
            duration: 10000
          });
        })
      });

      // Examen de ubicación completado (examen interno → api-rh socket)
      this.socketKPI.on("examen-completado", (body) => {
        runKpiNotification(() => {
          if (localStorage.getItem('notificaciones') === 'false') return

          const payload = parseExamenCompletadoPayload(body)
          if (!payload || !payload.folio) return

          const u = this.getdatosUsuarioERPERP
          const miId = u && (u.iderp || u.id_usuario || u.idusuario)
          if (payload.usuario_asignado && miId && Number(payload.usuario_asignado) !== Number(miId)) {
            return
          }

          const textoVendedora = payload.vendedora
            ? ` Vendedora: ${payload.vendedora}.`
            : ''

          this.$notify({
            group: 'foo',
            title: 'Examen de ubicación',
            text: `El folio: ${payload.folio} realizó el examen.${textoVendedora} Clic para abrir el chat.`,
            type: 'success',
            duration: 12000,
            data: payload,
          })
        })
      });

      // Alerta de Uso Inadecuado de Equipo
      this.socketKPI.on("alerta-equipo-uso", (body) => {
        runKpiNotification(() => {
          // body: { id_usuario, id_equipo, motivo }
          if (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.id_trabajador == body.id_usuario) {
            this.alertaEquipoUso.info = body;
            this.alertaEquipoUso.estatus = true;
          }
        })
      });

      // Bloqueo / desbloqueo de acceso al sistema
      this.socketKPI.off('acceso-sistema-bloqueo', this.onAccesoSistemaBloqueo)
      this.socketKPI.on('acceso-sistema-bloqueo', this.onAccesoSistemaBloqueo)

      // Prueba global de rendimiento WhatsApp/Twilio (puestos 11, 18 y 19)
      this.socketKPI.off('prueba-whatsapp-rendimiento', this.onPruebaWhatsappRendimiento)
      this.socketKPI.on('prueba-whatsapp-rendimiento', this.onPruebaWhatsappRendimiento)
    }

    // Socket Twilio (WhatsApp en vivo) PAUSADO — no conectar testfast ni listeners de bump.
    // Para reactivar: descomentar la línea siguiente.
    // this.inicializarSocketTwilio(usuarioId)
    console.log('[socket-twilio] PAUSADO (sin conexión / sin listeners de mensajes)')

    // $socket (main.js) ya usa VUE_APP_SOCKET_*; no duplicar listener KPI aquí.
    },

    /**
     * Socket solo para WhatsApp en vivo.
     * El webhook twilio.hooks corre en testfast → emite en ese IO, no en escuelakpi.
     */
    inicializarSocketTwilio(usuarioId) {
      if (this.socketTwilio) return

      const url = (process.env.VUE_APP_SOCKET_TWILIO_URL || 'https://testfast.club').replace(/\/?$/, '/')
      const path = process.env.VUE_APP_SOCKET_TWILIO_PATH || '/ws/socket.io'
      const uid = usuarioId || (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)

      console.log('[socket-twilio] conectando (solo WhatsApp)', {
        url,
        path,
        usuarioId: uid,
        envUrl: process.env.VUE_APP_SOCKET_TWILIO_URL || null,
        envPath: process.env.VUE_APP_SOCKET_TWILIO_PATH || null,
        nota: 'KPI/tickets siguen en VUE_APP_SOCKET_URL (escuelakpi); esto es solo mensajes WA',
      })

      this.socketTwilio = io(url, {
        transports: ['websocket'],
        path,
        query: { usuarioId: uid },
      })

      this.socketTwilio.on('connect', () => {
        console.log('[socket-twilio] CONNECT ok', {
          id: this.socketTwilio && this.socketTwilio.id,
          url,
          path,
          usuarioId: uid,
        })
      })

      this.socketTwilio.on('connect_error', (err) => {
        console.warn('[socket-twilio] CONNECT_ERROR', {
          message: err && err.message,
          url,
          path,
        })
      })

      this.socketTwilio.on('disconnect', (reason) => {
        console.warn('[socket-twilio] DISCONNECT', { reason })
      })

      // TEMP: desactivado actualización en vivo de mensajes/chats por socket
      // this.socketTwilio.off('twilio-unificado-bump', this.onTwilioUnificadoBump)
      // this.socketTwilio.on('twilio-unificado-bump', this.onTwilioUnificadoBump)
      // this.socketTwilio.off('recibir-mensaje-twilio', this.onRecibirMensajeTwilio)
      // this.socketTwilio.on('recibir-mensaje-twilio', this.onRecibirMensajeTwilio)
      // console.log('[socket-twilio] listeners activos: twilio-unificado-bump, recibir-mensaje-twilio')
      console.log('[socket-twilio] listeners de mensajes COMENTADOS (sin update en vivo)')
    },

    onTwilioUnificadoBump(body) {
      console.log('[socket-twilio] ← twilio-unificado-bump', {
        keys: body && typeof body === 'object' ? Object.keys(body) : null,
        twilio: body && body.twilio,
        usuario: body && body.usuario,
        iderp: body && body.iderp,
        Body: body && (body.Body || body.body),
        MessageSid: body && (body.MessageSid || body.messageSid),
        raw: body,
      })
      if (!body || typeof body !== 'object') return
      if (typeof this.backgroundUpdateChat === 'function') {
        this.backgroundUpdateChat(body)
        return
      }
      // Fallback: vistas sin backgroundUpdateChat usan el flujo legacy
      this.onRecibirMensajeTwilio(body)
    },

    // Handler del socket en vivo
    onRecibirMensajeTwilio(body) {
      console.log('[socket-twilio] ← recibir-mensaje-twilio', {
        keys: body && typeof body === 'object' ? Object.keys(body) : null,
        twilio: body && body.twilio,
        usuario: body && body.usuario,
        iderp: body && body.iderp,
        Body: body && (body.Body || body.body),
        MessageSid: body && (body.MessageSid || body.messageSid),
        tieneBackgroundUpdate: typeof this.backgroundUpdateChat === 'function',
        raw: body,
      })
      if (!body || typeof body !== 'object') return
      // Unificado / Agente: acomodo en vivo sin loader ni refetch
      if (typeof this.backgroundUpdateChat === 'function') {
        this.backgroundUpdateChat(body)
        return
      }
      const row = (body.mensaje && typeof body.mensaje === 'object' && body.usuario == null)
        ? body.mensaje
        : body
      if (!row.twilio && !row.usuario) return
      this.validarMensajeEntrante(row)
    },

    analyzeChat(twilio_wpp, user_wpp, id_usuario){
      this.$http.post("/api/analyze-chat", {twilio_wpp, user_wpp, id_usuario}).then(response=>{
      }).catch( error =>{
        this.validarError( error.response.data.message )
      })
    },

    validarEstatus () {
      this.mensajeProceso = ''

    	// Validamos la información del usuario y que tenga su WhatsAppservidor
    	if( !this.getdatosUsuarioERPERP.whatsappservidor ){ return this.validarErrorDirecto('FAVOR DE INGRESAR UN TELÉFONO') }

    	// Cargamos y abrimos un cuadro de dialogo
      this.cargar = true

    	// Creamos el payload que vamos a enviar
      const payload = {
      	from: this.getdatosUsuarioERPERP.whatsappservidor
      }

      // Genero la ruta oficial para hacer la petición
      this.url_servidor = this.getdatosUsuarioERPERP.url_servidor + 'whatsapp.activo'

      // Hago la petición
      return this.$http.post(this.url_servidor, payload).then(response=>{
      	this.cargar = false
      	this.dialog = true
      }).catch( error =>{
      	this.estatusWhats   = 3
      	this.dialog         = true
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    // Función para escanear el código QR
		escanerQR () {

    	// Validamos la información del usuario y que tenga su WhatsAppservidor
    	if( !this.getdatosUsuarioERPERP.whatsappservidor ){ return this.validarErrorDirecto('FAVOR DE INGRESAR UN TELÉFONO') }

    	// Formamos el payload para cargar el usuario
      const payload = {
      	from: this.getdatosUsuarioERPERP.whatsappservidor
      }

      this.cargar = true
    	this.dialog = false

      // Genero la ruta oficial para hacer la petición

      const path = 'whatsapp.inicializar'
      this.url_servidor = this.getdatosUsuarioERPERP.url_servidor + path

      // Realizo la petición
      return this.$http.post(this.url_servidor, payload).then(response=>{
      	this.dialog = true
      }).catch( error =>{
      	this.dialog = true
        this.validarError( error.response.data.message )
      })
    },

    // Detruir la sesión de wpp por si hay algún error en todo esto
		cerrarSesion () {

      // Desconectar sockets antes de destruir la sesión
      this.desconectarSockets();

    	// Validamos la información del usuario y que tenga su WhatsAppservidor
    	if( !this.getdatosUsuarioERPERP.whatsappservidor ){ return this.validarErrorDirecto('FAVOR DE INGRESAR UN TELÉFONO') }

      this.cargar = true
    	this.dialog = false

    	// Formamos el payload para cargar el usuario
      const payload = {
      	from: this.getdatosUsuarioERPERP.whatsappservidor
      }

      // Genero la ruta oficial para hacer la petición
      this.url_servidor = this.getdatosUsuarioERPERP.url_servidor + 'whatsapp.destruir'

      // Realizo la petición
      return this.$http.post(this.url_servidor, payload).then(response=>{
      	// Indico que ya no hay una sessión
      	this.estatusWhats = 2
      	this.cargar = false
      	this.dialog = true
      }).catch( error =>{
      	this.dialog = true
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },


    getNotificaciones(){
      // Realizo la petición
      return this.$http.get('notificaciones/' + this.getdatosUsuarioERPERP.iderp ).then(response=>{
        // Indico que ya no hay una sessión
        this.notificaciones = response.data

      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },


    validarMensajeEntrante( body ){
      // Sacamos el usuario que envío el mensaje
      const { usuario, twilio, mensaje, type, messageSid } = body

      let conversaciones = []
      let esLineaAgente = false

      if( twilio == 'whatsapp:+5218187047279' ){
        conversaciones = [...this.getConversacionesM];
      }

      if( twilio == 'whatsapp:+5215545703336' ){
        conversaciones = [...this.getConversacionesC];

      }

      if( twilio == 'whatsapp:+5213316971156' ){
        conversaciones = [...this.getConversacionesG];
      }

      if( twilio == 'whatsapp:+5218123255321' ){
        conversaciones = [...this.getConversacionesFast];
      }

      if( twilio == 'whatsapp:+5215540435043' || twilio == 'whatsapp:+5215534952943' ){
        conversaciones = [...this.getConversacionesAgente];
        esLineaAgente = true
      }

      if( twilio == 'whatsapp:+5218124384082'){
        conversaciones = [...this.getConversacionesCRM];
      }

      if( twilio == 'whatsapp:+5218124387901'){
        conversaciones = [...this.getConversacionesCRMFast];
      }

      // Ahora lo buscamos en las conversaciones
      const existeUsuario = conversaciones.find( el => el.usuario == usuario )

      // Chat nuevo en línea Agente: refrescar listado (socket solo UI; no reenvía WA)
      if (!existeUsuario && esLineaAgente && typeof this.initialize === 'function') {
        this.initialize(1)
        if (this.chat && this.chat.usuario === usuario && Array.isArray(this.mensajes)) {
          const ya = messageSid && this.mensajes.some((m) => m && m.messageSid === messageSid)
          if (!ya) this.mensajes.push(body)
          if (typeof this.onMensajeTwilioEnVivo === 'function') {
            this.onMensajeTwilioEnVivo(body)
          }
        }
        return
      }

      // Si existe.... hay que cambiarle el estatus
      if( existeUsuario ){
        const notifOff = localStorage.getItem('notificaciones') === 'false'
        const esMio = Number(body.mio) === 1
        const idx = conversaciones.findIndex((el) => el.usuario == usuario)

        if (idx >= 0) {
          conversaciones[idx].mensaje = mensaje
          conversaciones[idx].mio = esMio ? 1 : 0
          if (type != null) conversaciones[idx].type = type

          // Lead o asesor humano → quitar chip azul de reasignado
          const iderpMsg = Number(body.iderp)
          const limpiaReasig = !esMio
            || (Number.isFinite(iderpMsg) && iderpMsg > 0 && iderpMsg !== 3176)
          if (limpiaReasig) {
            conversaciones[idx].reasignado = 0
            if (esMio) conversaciones[idx].sinleer = 0
            if (this.chat && this.chat.usuario == usuario) {
              this.$set(this.chat, 'reasignado', 0)
              if (esMio) this.$set(this.chat, 'sinleer', 0)
            }
          }

          // Subir al tope
          if (idx > 0) {
            const [item] = conversaciones.splice(idx, 1)
            conversaciones.unshift(item)
          }

          // Fecha México (nunca ISO/Z) para ordenar igual que al enviar
          try {
            const { formatFechaMexicoFront } = require('@/utils/twilioFechaMexico')
            conversaciones[0].fecha_ultimo_mensaje = formatFechaMexicoFront(
              body.fecha_ultimo_mensaje || body.fecha_creacion || Date.now()
            )
          } catch (_) {
            conversaciones[0].fecha_ultimo_mensaje = body.fecha_ultimo_mensaje
              || body.fecha_creacion
              || conversaciones[0].fecha_ultimo_mensaje
          }

          const chatAbierto = !!(this.chat && this.chat.usuario == usuario)

          if (chatAbierto) {
            const ya = messageSid
              && Array.isArray(this.mensajes)
              && this.mensajes.some((m) => m && m.messageSid === messageSid)
            if (!ya) {
              this.mensajes.push(body)
              this.$nextTick(() => {
                const el = document.getElementById('scroll-target')
                if (el) el.scrollTop = el.scrollHeight
              })
            }
            if (typeof this.onMensajeTwilioEnVivo === 'function') {
              this.onMensajeTwilioEnVivo(body)
            }
          } else if (!notifOff && !esMio) {
            conversaciones[0].sinleer = (Number(conversaciones[0].sinleer) || 0) + 1
            conversaciones[0].tiemporestante = 24
          }
        }
      }

      if( twilio == 'whatsapp:+5218187047279' ){
        this.guardarConversacionesM( conversaciones )
      }

      if( twilio == 'whatsapp:+5215545703336' ){
        this.guardarConversacionesC( conversaciones )
      }

      if( twilio == 'whatsapp:+5213316971156' ){
        this.guardarConversacionesG( conversaciones )
      }

      if( twilio == 'whatsapp:+5218123255321' ){
        this.guardarConversacionesFast( conversaciones )
      }

      if( twilio == 'whatsapp:+5215540435043' || twilio == 'whatsapp:+5215534952943' ){
        this.guardarConversacionesAgente( conversaciones )
      }

      if( twilio == 'whatsapp:+5218124384082'){
        this.guardarConversacionesCRM( conversaciones )
      }

      if( twilio == 'whatsapp:+5218124387901'){
        this.guardarConversacionesCRMFast( conversaciones )
      }
    },

    desconectarSockets() {
      // Desconectar socket
      if (this.$socket) {
        this.$socket.disconnect();
      }
      if (this.socketKPI) {
        this.socketKPI.off('prueba-whatsapp-rendimiento', this.onPruebaWhatsappRendimiento)
        this.socketKPI.off('acceso-sistema-bloqueo', this.onAccesoSistemaBloqueo)
        this.socketKPI.disconnect()
        this.socketKPI = null
      }
      if (this.socketTwilio) {
        this.socketTwilio.off('recibir-mensaje-twilio', this.onRecibirMensajeTwilio)
        this.socketTwilio.off('twilio-unificado-bump', this.onTwilioUnificadoBump)
        this.socketTwilio.disconnect()
        this.socketTwilio = null
      }
    }

  },
}
